// LICENSE_CODE ZON
'use strict';

/*jslint browser:true, es6:true, node:true, react:true*/
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useLocation, useHistory, Redirect } from 'react-router-dom';
import { renderRoutes, matchRoutes } from 'react-router-config';
import { Content } from './lib/content';
import cn from 'classnames';
import hopt from 'hola_opt';
import zutil from 'zutil';
import etask from 'zetask';
import zcountry from 'zcountry';
import www_util from 'hola_pub_util';
import { use_search } from './ui/use_search.tsx';
import { Provider } from './context.js';
import { Hola_footer } from './ui/footer.tsx';
import { Navbar } from './ui/navbar.js';
import { Settings_context, Settings_provider } from './settings_ctx.tsx';
import { Data_provider } from './data_ctx.tsx';
import { Meta } from './meta.tsx';
import { use_qs } from './lib/use_qs.ts';
import { Allow_cookies } from './ui/allow_cookies.tsx';
import { Client_hints_provider } from './client_hints.tsx';
import { Cookie_consent } from './ui/cookie_consent.tsx';
import { Old_design_popup } from './ui/old_design_popup.tsx';
import { Navbar_hola2023 } from './ui/navbar_hola2023.tsx';
import { Br_footer } from './ui/browser/br_footer.tsx';
import { Intercom } from './ui/intercom.tsx';
import hola_dark_theme from './css/core/hola_dark_theme.module.less';
import hola_brand_theme from './css/core/hola_brand_theme.module.less';
import hola_2023_theme from './css/core/hola_2023_theme.module.less';
import hola_theme from './css/core/hola_theme.module.less';
import './css/core/bootstrap_polyfill.less';
import experiment_init from './experiment_init';
// @ts-ignore
import { fetch } from '/util/fetch.js';
import { get_aliased_pathname, get_pathname_for_redirect } from '../../hola/pub/lib/use_pathname';
import { Install_popup } from '../../hola/pub/pages/hola.org/install_popup';
import { Html, Html_editor } from '../../hola/pub/lib/html';
import { Title, Title_editor } from '../../hola/pub/pages/hola.org/resolvers/title';
import { Spacer, Spacer_editor } from '../../hola/pub/pages/hola.org/resolvers/spacer';
import { Products_tabs, Products_tabs_editor } from '../../hola/pub/pages/hola.org/resolvers/products_tabs';
import { Features, Features_editor } from '../../hola/pub/pages/hola.org/resolvers/features';
import { Cards, Cards_editor } from '../../hola/pub/pages/hola.org/resolvers/cards';
import { Paragraph, Paragraph_editor } from '../../hola/pub/pages/hola.org/resolvers/paragraph';
import { Cta, Cta_Editor } from '../../hola/pub/pages/hola.org/resolvers/cta';
import { Image, Image_editor } from '../../hola/pub/pages/hola.org/resolvers/image';
import { Countries, Countries_editor } from '../../hola/pub/pages/hola.org/resolvers/countries';
import { Store_review, Store_review_editor } from '../../hola/pub/pages/hola.org/resolvers/review';
import { Faq, Faq_editor } from '../../hola/pub/pages/hola.org/resolvers/faq';
import { Product_hero, Product_hero_editor } from '../../hola/pub/pages/hola.org/resolvers/product_hero';
import { One_review, One_review_editor } from '../../hola/pub/pages/hola.org/resolvers/one_review';
var themes = {
  default: hola_theme,
  dark: hola_dark_theme,
  brand: hola_brand_theme,
  hola2023: hola_2023_theme
};
var r_or_call = v => {
  if (typeof v == 'function') return v();
  return v;
};
var qs_has_embed_label = qs => {
  var embed_style_login = qs.embed_style_login;
  var next = qs.next || '';
  return !!embed_style_login || next.indexOf('embed_style_login') > -1 || next.indexOf('vpn_config') > -1;
};
var static_resolvers = {
  'Html': {
    tag: Html,
    editor: Html_editor,
    props: {
      html: `<h2>Title</h2><p>Text in p1</p>
              <p class="p2">Text in p.p2</p>
              <p class="p12 semi">Text with class p12 and semi</p>`
    }
  },
  'Spacer': {
    tag: Spacer,
    editor: Spacer_editor,
    props: {
      margin: 16,
      margin_tablet: 16,
      margin_mobile: 16,
      unit: 'px'
    }
  },
  'Title': {
    tag: Title,
    editor: Title_editor,
    props: {
      gradient: false,
      title: 'Title',
      subtitle: 'Subtitle'
    }
  },
  'Cta': {
    tag: Cta,
    editor: Cta_Editor,
    props: {
      gradient: false,
      title: 'Title',
      subtitle: 'Subtitle'
    }
  },
  'Image': {
    tag: Image,
    editor: Image_editor,
    props: {
      gradient: false,
      img: 'http://hola.org/cms/wp-content/uploads/2024/09/' + 'fastwatch_img.png'
    }
  },
  'Products_tabs': {
    tag: Products_tabs,
    editor: Products_tabs_editor,
    props: {
      browsers: true,
      mobile: true,
      desktop: true,
      tv: true,
      other: true
    }
  },
  'Features': {
    tag: Features,
    editor: Features_editor,
    props: {
      title: 'You\'ll love Hola',
      features: [{
        title: 'Ultra-fast and stable connection',
        description: 'Our high-speed stable network will get you ' + 'the best connectivity out there!',
        image: 'http://hola.org/cms/wp-content/uploads/2024/09/' + 'fastwatch_img.png'
      }, {
        title: 'Use across all your devices',
        description: 'Use Hola on your tablet, TV, laptop,' + ' or phone with our selection of apps!',
        image: 'http://hola.org/cms/wp-content/uploads/2024/09/' + 'devices_img.png'
      }, {
        title: '24/7 Customer Support Center',
        description: 'Get in touch anytime. We\'re there whenever ' + 'you need us!',
        image: 'http://hola.org/cms/wp-content/uploads/2024/09/' + 'support_img.png'
      }]
    }
  },
  'Cards': {
    tag: Cards,
    editor: Cards_editor,
    props: {
      title: 'Need Help?',
      cards: [{
        link: '',
        description: 'Our high-speed stable network will get you ' + 'the best connectivity out there!',
        image: 'http://hola.org/cms/wp-content/uploads/2024/09/' + 'fastwatch_img.png'
      }, {
        link: '/premium_support',
        description: 'Use Hola on your tablet, TV, laptop, or' + ' phone with our selection of apps!',
        image: 'http://hola.org/cms/wp-content/uploads/2024/09/' + 'devices_img.png'
      }]
    }
  },
  'Paragraph': {
    tag: Paragraph,
    editor: Paragraph_editor,
    props: {
      title: 'Your internet is truly yours with Hola Premium',
      text: 'Our mission is to create a truly borderless internet—one' + ' that is free',
      image: 'http://hola.org/cms/wp-content/uploads/2024/09/' + 'devices_img.png',
      image_left: true
    }
  },
  'Countries': {
    tag: Countries,
    editor: Countries_editor,
    props: {
      title: 'Your internet is truly yours with Hola Premium',
      description: 'Our mission is to create a truly borderless' + ' internet—one that is free',
      bg_color: null
    }
  },
  'Store_review': {
    tag: Store_review,
    editor: Store_review_editor,
    props: {
      title: 'Your internet is truly yours with Hola Premium',
      store: 'App Store',
      store_img: ''
    }
  },
  'Faqs': {
    tag: Faq,
    editor: Faq_editor,
    props: {
      title: 'Common questions people ask',
      faqs: []
    }
  },
  'Product_hero': {
    tag: Product_hero,
    editor: Product_hero_editor,
    props: {
      src: 'Common questions people ask'
    }
  },
  'One_review': {
    tag: One_review,
    editor: One_review_editor
  }
};
export var App = function App(props) {
  var _matched$, _app_settings$meta, _app_settings$meta$pa, _app_settings$meta2, _app_settings$meta2$p, _app_settings$meta3, _app_settings$meta3$p, _app_settings$meta4, _app_settings$meta4$p, _app_settings$meta5, _app_settings$meta6;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    client = _useState2[0],
    set_client = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    cookie_ready = _useState4[0],
    set_cookie_ready = _useState4[1];
  var history = useHistory();
  if (window) {
    // XXX dmitriiz: dirty hack: we have to send it to a lot places in
    // code
    window.react_history = history;
  }
  var _useLocation = useLocation(),
    current_pathname = _useLocation.pathname,
    location_state = _useLocation.state;
  var pathname = get_aliased_pathname(current_pathname);
  var pn_redirect = get_pathname_for_redirect(location.pathname);
  var navigated = useRef(false);
  var top_portal_ref = useRef();
  var navbar_portal_ref = useRef();
  var footer_portal_ref = useRef();
  var routes = props.route.routes;
  var i18n = props.i18n_instance;
  var matched = matchRoutes(routes, pathname) || [];
  var silent_state = useMemo(() => {
    return {
      path: matched && matched[0] && matched[0].route.path
    };
  }, []);
  var _useState5 = useState({
      overrides: _objectSpread({}, props.overrides),
      meta: _objectSpread({}, props.meta_overrides),
      resolvers: static_resolvers,
      save_overrides: (pn, conf, just_state = undefined) => {
        set_app_settings(app_s => _objectSpread(_objectSpread({}, app_s), {}, {
          overrides: _objectSpread(_objectSpread({}, app_s.overrides), {}, {
            [pn]: conf
          })
        }));
        if (conf.loading || conf.error || just_state) return;
        fetch(`/www_cms/save_overrides?path=${encodeURIComponent(pn)}`, {
          method: 'POST',
          json: true,
          body: {
            override: conf
          }
        });
      },
      save_meta: (pn, conf, just_state = undefined) => {
        set_app_settings(app_s => _objectSpread(_objectSpread({}, app_s), {}, {
          meta: _objectSpread(_objectSpread({}, app_s.meta), {}, {
            [pn]: conf
          })
        }));
        if (conf.loading || conf.error || just_state) return;
        fetch(`/www_cms/save_meta?path=${encodeURIComponent(pn)}`, {
          method: 'POST',
          json: true,
          body: {
            meta: conf
          }
        });
      }
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    app_settings = _useState6[0],
    set_app_settings = _useState6[1];
  useEffect(() => {
    if (app_settings.overrides[pathname]) return;
    app_settings.save_overrides(pathname, {
      loading: true
    }, true);
    etask(function* () {
      var _location;
      var lng = props.i18n_instance.language;
      var overrides = yield fetch(`/www_cms/get_overrides?path=${encodeURIComponent(pathname)}&lng=${lng}&reqp=${encodeURIComponent((_location = location) === null || _location === void 0 ? void 0 : _location.pathname)}`);
      if (overrides && overrides.status == 'ok') {
        var _overrides$translatio;
        props.i18n_instance.addResourceBundle(lng, 'translation', ((_overrides$translatio = overrides.translations[lng]) === null || _overrides$translatio === void 0 ? void 0 : _overrides$translatio.translation) || {});
        app_settings.save_overrides(pathname, overrides.overrides, true);
        app_settings.save_meta(pathname, overrides.meta, true);
      } else app_settings.save_overrides(pathname, {
        error: true
      }, true);
    });
  }, [pathname, app_settings]);
  useMemo(() => {
    hopt.user_currency = zcountry.currency_white_list(hopt.user_currency);
    hopt.user_currencies = [hopt.user_currency];
  }, []);
  useEffect(() => {
    // XXX dmitriiz: hotfix for login.js. there is modal window out of
    // context. We need to get rid of that pattern and remove ui from
    // login.js
    window.global_app_themes = themes;
  }, []);
  useEffect(() => {
    var path = matched && matched[0] && matched[0].route.path;
    if (navigated.current && history.action != 'POP') {
      if (silent_state.path != path) window.scrollTo(0, 0);
    } else navigated.current = true;
    silent_state.path = path;
  }, [pathname]);
  useEffect(() => {
    history.block(() => www_util.before_spa());
    if (window.postponed_js) {
      setTimeout(() => {
        window.postponed_js.forEach(js => {
          var s_el = document.createElement('script');
          s_el.src = js;
          s_el.onerror = function () {
            window.handle_fallback(this);
          };
          document.head.appendChild(s_el);
        });
      }, 0);
    }
    set_client(true);
  }, []);
  var search = use_search(props);
  var t_conf = zutil.get(hopt, 'www_hola.translation', {});
  var t_enabled = t_conf.enabled && matched.every(({
    route
  }) => {
    return route.translation && route.translation.enabled && (!t_conf.only || t_conf.only.indexOf(route.path) > -1);
  });
  var r_translation = matched === null || matched === void 0 ? void 0 : (_matched$ = matched[0]) === null || _matched$ === void 0 ? void 0 : _matched$.route.translation;
  var route_props = Object.assign({
    top_portal_ref,
    navbar_portal_ref,
    footer_portal_ref,
    search,
    t_enabled,
    r_translation
  }, props);
  if (route_props.location) route_props.location = _objectSpread(_objectSpread({}, route_props.location), {}, {
    pathname: pathname
  });
  useEffect(() => {
    i18n.changeLanguage(t_enabled ? i18n.language || props.lang : 'en');
  }, [t_enabled]);
  var _useState7 = useState(1),
    _useState8 = _slicedToArray(_useState7, 2),
    reload = _useState8[0],
    set_reload = _useState8[1];
  useEffect(() => {
    if (matched[0].route && !matched[0].route.loaded) {
      matched[0].route.on_load = () => {
        set_reload(r => r + 1);
        matched[0].route.on_load = undefined;
      };
    }
  }, [matched[0].route && matched[0].route.loaded]);
  var headless = matched.every(({
    route
  }) => r_or_call(route.headless)) || (location_state === null || location_state === void 0 ? void 0 : location_state.headless);
  var footless = matched.every(({
    route
  }) => r_or_call(route.footless)) || (location_state === null || location_state === void 0 ? void 0 : location_state.footless);
  if ((app_settings === null || app_settings === void 0 ? void 0 : (_app_settings$meta = app_settings.meta) === null || _app_settings$meta === void 0 ? void 0 : (_app_settings$meta$pa = _app_settings$meta[pathname]) === null || _app_settings$meta$pa === void 0 ? void 0 : _app_settings$meta$pa.headless) !== undefined) headless = app_settings === null || app_settings === void 0 ? void 0 : (_app_settings$meta2 = app_settings.meta) === null || _app_settings$meta2 === void 0 ? void 0 : (_app_settings$meta2$p = _app_settings$meta2[pathname]) === null || _app_settings$meta2$p === void 0 ? void 0 : _app_settings$meta2$p.headless;
  if ((app_settings === null || app_settings === void 0 ? void 0 : (_app_settings$meta3 = app_settings.meta) === null || _app_settings$meta3 === void 0 ? void 0 : (_app_settings$meta3$p = _app_settings$meta3[pathname]) === null || _app_settings$meta3$p === void 0 ? void 0 : _app_settings$meta3$p.footless) !== undefined) footless = app_settings === null || app_settings === void 0 ? void 0 : (_app_settings$meta4 = app_settings.meta) === null || _app_settings$meta4 === void 0 ? void 0 : (_app_settings$meta4$p = _app_settings$meta4[pathname]) === null || _app_settings$meta4$p === void 0 ? void 0 : _app_settings$meta4$p.footless;
  var br_footer = matched.every(({
    route
  }) => r_or_call(route.br_footer)) || (location_state === null || location_state === void 0 ? void 0 : location_state.br_footer);
  var qs = use_qs();
  var consent_test = qs.consent_test;
  var hide_allow_cookies = matched.every(({
    route
  }) => r_or_call(route.hide_allow_cookies)) || qs_has_embed_label(qs) || props.is_eu || consent_test;
  var _ref = matched && matched[0] || {},
    route = _ref.route;
  var overridden_meta = ((_app_settings$meta5 = app_settings.meta) === null || _app_settings$meta5 === void 0 ? void 0 : _app_settings$meta5[pathname]) || {};
  var merged_route = _objectSpread(_objectSpread({}, route), overridden_meta);
  var _host = props.host && props.host.replace(/\./g, '_');
  var _page = pathname.slice(1).replace(/\//g, '_') || 'homepage';
  var wrapper_cls = cn(props.host && `host-${_host}`, `page-${_page}`, props.is_portal || qs.no_animation ? 'no-animation' : '', {
    client,
    portal: props.is_portal
  });
  useEffect(() => {
    if (!route.click_tracking) return;
    var host = route.click_host || _host;
    var handle_click = event => {
      var _www_util$get_click_d = www_util.get_click_data(event.target),
        id = _www_util$get_click_d.id,
        info = _www_util$get_click_d.info;
      if (id) {
        var perr_id = `www_click_${host || 'unknown_host'}_${id}`;
        www_util.perr({
          id: perr_id,
          info,
          build: {
            pathname
          }
        });
      }
    };
    document.addEventListener('click', handle_click);
    return () => document.removeEventListener('click', handle_click);
  }, [_page]);
  var is_embed_style = useMemo(() => qs.embed_hola_browser, []);
  var def_keywords = 'hola vpn for windows, mac, ios, vpn extension ' + 'for browser';
  var switch_opt = {
    location: _objectSpread({}, props.location)
  };
  switch_opt.location.pathname = pathname;
  if (pn_redirect) return /*#__PURE__*/React.createElement(Redirect, {
    to: pn_redirect
  });
  return /*#__PURE__*/React.createElement(Data_provider, _extends({}, props, {
    route: route
  }), /*#__PURE__*/React.createElement(Provider, _extends({}, props, {
    headless: headless
  }), /*#__PURE__*/React.createElement(Settings_provider, _extends({}, props, {
    location: window.location,
    route: route,
    themes_add: themes,
    app_settings: app_settings,
    set_app_settings: set_app_settings
  }), /*#__PURE__*/React.createElement(Meta, {
    props: props,
    routes: routes,
    matched: matched,
    def_keywords: def_keywords,
    overrided_meta: app_settings === null || app_settings === void 0 ? void 0 : (_app_settings$meta6 = app_settings.meta) === null || _app_settings$meta6 === void 0 ? void 0 : _app_settings$meta6[pathname]
  }, /*#__PURE__*/React.createElement(Client_hints_provider, props, /*#__PURE__*/React.createElement(Settings_context.Consumer, null, value => /*#__PURE__*/React.createElement("div", {
    id: 'page_content_wrapper',
    key: reload,
    className: cn(wrapper_cls, value.theme.root, is_embed_style && 'embed_in_browser')
  }, /*#__PURE__*/React.createElement(Install_popup, null), /*#__PURE__*/React.createElement(Content, {
    just_meta: true,
    edit_mode: !!qs.edit_meta_mode
  }), /*#__PURE__*/React.createElement(Intercom, {
    with_intercom: props.with_intercom,
    app_id: 'taj8ybxt',
    need_plus: true
  }), ['hola2023', 'default', 'toolip'].includes(value.theme_name) ? /*#__PURE__*/React.createElement(Navbar_hola2023, _extends({}, props, {
    route: route
  })) : /*#__PURE__*/React.createElement(Navbar, _extends({
    ref: {
      top_portal_ref,
      navbar_portal_ref
    },
    search: search,
    t_enabled: t_enabled,
    r_translation: r_translation
  }, props, {
    route: route
  })), renderRoutes(routes, route_props, switch_opt), !hide_allow_cookies && /*#__PURE__*/React.createElement(Allow_cookies, null), !cookie_ready && (consent_test || props.is_eu && !props.cookie_value) ? /*#__PURE__*/React.createElement(Cookie_consent, {
    on_apply: () => {
      set_cookie_ready(true);
    }
  }) : null, !footless && !br_footer && /*#__PURE__*/React.createElement(Hola_footer, {
    user_country: props.user_country,
    ref: footer_portal_ref,
    host: props.host,
    t_enabled: t_enabled,
    r_translation: r_translation,
    route_opt: merged_route
  }), br_footer && /*#__PURE__*/React.createElement(Br_footer, null), /*#__PURE__*/React.createElement(Old_design_popup, null))))))));
};